<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
      :title="page"
      :breadcrumbs="breadcrumbs"
      icon="mdi-package-variant"
    ></vuse-section-definition>
    <v-container fluid >
      <v-tabs v-model="tabIndex">
        <v-tab v-for="item in items" :key="item.id">{{ item.tab }}</v-tab>
      </v-tabs>
    </v-container>
    <v-container fluid>
      <v-tabs-items v-model="tabIndex" class="min-width">
        <v-tab-item active class="">
          <v-row class="mx-1">
            <v-col cols="12" class="content_category mb-3 rounded-lg">
              <v-row class="pl-3">
                <v-col cols="12" class="content_category rounded-lg d-flex">
                  <h3 class="mt-2">Banner</h3>
                  <v-btn
                      class="ml-5 mb-5"
                      color="primary"
                      @click="addBanner()"
                  >
                    Thêm
                  </v-btn>
                </v-col>
                <v-col cols="6" class="content_category mb-3 rounded-lg" v-for="(item, index) in banners" :key="index">
                  <form-link class="content_category mr-2 rounded-lg content_banner" :banner="item" @updateBanner="updateBanner" @removeBanner="removeBanner" :index="index"> </form-link>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="content_category mb-3 rounded-lg">
              <v-col>
                <v-col>
                  <v-row>
                    <h3 class="ml-1 mt-2 mb-3">Mô tả</h3>
                  </v-row>
                </v-col>
                <v-col cols="12" class="mb-3">
                  <v-row>
                    <v-row>
                      <v-col cols="12" class="content-textarea">
                        <ck-content class="ck-news" :content="description" @getData="value => description = value"  />
                        <!-- <v-textarea
                            background-color="#EDF2F7"
                            filled
                            label="Mô tả"
                            v-model="description"
                            placeholder="Nhập mô tả ngắn"
                        >
                        </v-textarea> -->
                      </v-col>
                    </v-row>
                  </v-row>
                </v-col>
              </v-col>
            </v-col>
          </v-row>
          <v-col cols="12" class="text-center mt-3">
            <v-btn color="primary" width="180" @click="save()"> Lưu </v-btn>
          </v-col>
        </v-tab-item>
        <v-tab-item>
          <ConfigShowroom></ConfigShowroom>
        </v-tab-item>
        <v-tab-item>
          <div class="px-4 py-4">
            <h1>Setting thông báo</h1>
            <div>
              <v-text-field
                  background-color="#EDF2F7"
                  filled
                  label="Link hướng dẫn"
                  v-model="config_showroom_link.link"
                  placeholder="Nhập link hướng dẫn"
              ></v-text-field>
            </div>
            <div>
              <v-btn color="primary" width="180" @click="saveLink()"> Lưu </v-btn>
            </div>
          </div>
        </v-tab-item>
      </v-tabs-items>

    </v-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import CkContent from "@/components/ck-content"
import { replaceCkContent } from '@/utils/helpers'
import {
  GET_CONFIG_SHOWROOM,
  UPDATE_CONFIG_SHOWROOM,
  GET_CONFIG_SHOWROOM_LINK,
  UPDATE_CONFIG_SHOWROOM_LINK
} from "@/store/modules/configs";
import FormLink from "@/views/Pages/config/util/form_link";
import ConfigShowroom from "@/views/Pages/show_room/config_showroom"

export default {
  components: { FormLink, CkContent, ConfigShowroom },
  data() {
    return {
      tabIndex: 0,
      items: [
        {id: 0, tab: "Trang chủ showroom"},
        // { id: 1, tab: "Countdown" },
        {id: 1, tab: "danh mục showroom"},
        {id: 2, tab: "config thông báo"},
      ],
      banners: [],
      banner: {
          photo_url: "",
          photo_url_mobile: "",
          type: null,
          link: {
            type: null,
            object_id: null,
            url: null,
          }
      },
      description: null,
      list_type: [
        {
          id: "category",
          text: "category",
        },
        {
          id: "brand",
          text: "brand",
        },
        {
          id: "tag",
          text: "tag",
        },
      ],
      types: [
        {
          id: 1,
          text: "Link theo loại",
        },
        {
          id: 2,
          text: "Link theo URL",
        },
      ],
      image: {},
      src: "",
      category: {
        id: -1,
      },
      page: "Quản lý hệ thống cửa hàng",

      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Quản lý trang",
          disabled: true,
        },
        {
          text: "Hệ thống cửa hàng",
          disabled: true,
        },
      ],
      errors: 0,
      text_seo: "",
      SEO: [],
    };
  },
  computed: {
    ...mapGetters({
      config_showroom: "config_showroom",
      config_showroom_link: "config_showroom_link",
    }),
  },
  watch: {
    config_showroom(val) {
      console.log(val);
      this.banners = val.banner ?? [];
      this.description = val.description ?? '';
    },
  },
  async created() {
    await this.$store.dispatch(`${GET_CONFIG_SHOWROOM}`);
    await this.$store.dispatch(`${GET_CONFIG_SHOWROOM_LINK}`);
  },
  methods: {
    saveLink() {
      let payload = {
        link: this.config_showroom_link.link
      }
      this.$store.dispatch(`${UPDATE_CONFIG_SHOWROOM_LINK}`, payload).then(data=>{
        if (data.status) {
          this.$toasted.success('Cập nhật thành công!', {
            duration:1000,
            position:'top-center'
          })
        }
      })
    },
    save() {
      let _this = this;
      let body = {
        banner: this.banners,
        description: replaceCkContent(this.description),
      };
      if (body.banner.type == 1) {
        body.banner.link.url = null;
      }
      if (body.banner.type == 2) {
        body.banner.link.object_id = null;
        body.banner.link.type = null;
      }
      this.$store
        .dispatch(`${UPDATE_CONFIG_SHOWROOM}`, body)
        .then((data) => {
          if (data.data.status === 1) {
            this.$toasted.success('Cập nhật thành công!', {
              duration:1000,
              position:'top-center'
            })
            _this.$store.dispatch(`${GET_CONFIG_SHOWROOM}`);
          } else {
            alert(data.data.errors);
          }
        });
    },
    addBanner() {
      this.banners.push({
        photo_url: this.banner.photo_url,
        photo_url_mobile: this.banner.photo_url_mobile,
        type: this.banner.type,
        link: this.banner.link,
      });
    },
    updateBanner(val) {
      this.banners[val.index] = val.banner
    },
    removeBanner(i) {
      this.banners.splice(i, 1);
      this.$forceUpdate();
    }
  },
};
</script>
<style lang="scss">
.content_property {
  padding: 15px;
  border-style: groove;
}
.content_banner {
  padding: 15px;
  border-style: groove;
}
.content_category1 {
  background: #ffffff !important;
}
.content_category {
  background: #ffffff !important;
  .v-input__control {
    height: 65px !important;
  }
  .content-textarea .v-input__control {
    height: 165px !important;
  }
  .v-input--checkbox .v-input__control {
    height: 20px !important;
  }
}
.production .ck-editor__main .ck-content {
  height: 140px;
}
.right {
  float: right;
}
</style>